import { AppData, BookingData, BookingTool } from "../../AppDataProvider";
import {
  ResourceAllocationType,
  ResourceSelectionMode,
  TierPricingType,
} from "../../../GeneratedGraphQL";

import { Mixpanel } from "../../../mixpanel/mixpanel";

export type BackFromAvailabilityStepOpts = {
  appData: AppData;
};

const getPreviousStep = ({
  bookingData,
  bookingTool,
}: {
  bookingData: BookingData;
  bookingTool: BookingTool;
}) => {
  const { services } = bookingTool;
  const { tier, organisation } = bookingData;

  const resourceSelectionBeforeAvailability =
    bookingData.organisation?.resourceSelectionBeforeAvailability;

  const filteredServices = services.edges.filter(
    ({ node }) => node.organisation._id === organisation?._id,
  );

  /**
   * If we have been provided a resourceId in the url params,
   * we do not want to return to the resource step. We also do
   * not want to return to the resource step if there is only
   * one resource to choose from.
   */
  const urlParams = new URLSearchParams(window.location.search);
  const preFillResourceId = urlParams.get("resourceId");
  const resourcesOnService = bookingData.service?.numberOfResources;

  if (
    bookingTool.resourceSelectionMode !== ResourceSelectionMode.Disabled &&
    bookingData.service?.resourceAllocationType ===
      ResourceAllocationType.Any &&
    resourceSelectionBeforeAvailability &&
    !preFillResourceId &&
    resourcesOnService &&
    resourcesOnService > 1
  ) {
    return "resources";
  }

  if (tier && tier.pricingType === TierPricingType.Single) {
    return "multiTier";
  } else if (tier && tier.pricingType === TierPricingType.Multiple) {
    return "pricePoints";
  }

  if (bookingTool.forceServiceSelection || filteredServices.length !== 1) {
    return "services";
  } else {
    return "organisations";
  }
};

export const backFromAvailabilityStep = (
  options: BackFromAvailabilityStepOpts,
): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "availability" } });

  const { bookingData, bookingTool } = options.appData;

  const targetStep = getPreviousStep({ bookingData, bookingTool });

  return {
    ...options.appData,
    currentStep: targetStep,
  };
};
